import Vue from "vue";
import Vuex from "vuex";
import toolClass from "../utils/toolClass.js";
import { clearSystemLock } from "../utils/systemLock";

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
	state: {
		user: false,
		// 缓存的数据
		levelList: [],
		activeName: "",
		activeMenu: "",
		menuUrl: "",
		permission: [],
		messageNum: 0,
		labelList: [],
		updataIndex: "",
		isLoading: false
	},
	mutations: {
		// 登录
		login(state, user) {
			clearSystemLock();
			state.user = user;
			localStorage.setItem("userInfo", user);
		},
		// 退出
		logout(state, user) {
			clearSystemLock();
			state.user = "";
			localStorage.setItem("userInfo", "");
			localStorage.setItem("logintoken", "");
		},
		updateLevelList(state, data) {
			state.levelList.push(data);
			state.levelList = toolClass.prototype.arrToSet(state.levelList);
		},
		updateActiveName(state, name) {
			state.activeName = name;
			state.activeMenu = state.activeName.substr(1);
		},
		updateActiveMenu(state, name) {
			state.activeMenu = state.activeName.substr(1);
		},

		updateMessageNum(state, num) {
			state.messageNum = num;
		},

		deleteLevelList(state, path) {
			const i = state.levelList.findIndex((x) => x.path === path);
			if (i !== -1) {
				state.levelList.splice(i, 1);
			}
		},

		clearLevelList(state, data) {
			state.levelList = [];
		},
		SET_PERMISSION(state, permission) {
			//permission 为传入的权限标识集合
			// 传入的权限集合 赋值给状态中的 permission
			state.permission = permission;
		},
		activeMenu(state, name) {
			state.activeName = name;
		},
		UpdataLabelList(state, data) {
			state.labelList = data;
		},
		UpdataIndex(state, data) {
			state.updataIndex = data;
		},
		setLoading(state, value) {
			state.isLoading = value;
		}
	},
	actions: {
		// 官方不推荐直接修改mutation， 可使用actions来提交 mutation

		SET_PERMISSION(context, permission) {
			const result = permission.reduce((acc, item) => {
				acc[item.menuCode] = { ...item };
				return acc;
			}, {});
			// 提交到 mutation 中的 SET_PERMISSION 函数
			context.commit("SET_PERMISSION", result);
		}
	}
});
